import { Anchor, Button, Center, Paper, Stack, Text, Title } from '@mantine/core'
import { useAuth } from '../auth/AuthProvider'

export default function SignIn() {
  const { signIn } = useAuth()
  return (
    <Center mih="100vh" p="md">
      <Paper withBorder p="xl" w={400} maw="100%">
        <Stack gap="xs">
          <Anchor href="https://racedash.live" className="wordmark" underline="never">
            RaceDash<span>.</span>live
          </Anchor>
          <Title order={1} size="h3">
            Sign in
          </Title>
          <Text c="dimmed" size="sm">
            Everything here is behind an account. Your dashboards, your team, your links.
          </Text>
          <Button fullWidth mt="md" onClick={() => void signIn()}>
            Continue with Google
          </Button>
        </Stack>
      </Paper>
    </Center>
  )
}
